import React from "react";
import { useSensors } from "../../../api/queries/sensors";
import { Loading } from "../../loadingContext";

export const SiteSensorHistoryDialog = ({ siteId, siteName, unSetDialog }) => {
  const sensors = useSensors({ activeOnly: false });

  if (sensors.isLoading) {
    return <Loading />;
  }

  if (sensors.isError) {
    return (
      <div className="w-full max-w-3xl p-4">
        <h3 className="font-bold text-lg mb-2">Sensor history — {siteName}</h3>
        <div className="alert alert-error">Failed to load sensors.</div>
        <div className="flex justify-end mt-4">
          <button className="btn" onClick={unSetDialog}>Close</button>
        </div>
      </div>
    );
  }

  const rows = (sensors.data || [])
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter((s) => s.SiteID === siteId)
    .sort((a, b) => {
      const aStart = a.StartDate?.toMillis?.() ?? 0;
      const bStart = b.StartDate?.toMillis?.() ?? 0;
      return bStart - aStart; // newest first
    });

  return (
    <div className="w-full max-w-3xl">
      <h3 className="font-bold text-lg p-4">Sensor history — {siteName}</h3>
      <div className="overflow-x-auto w-full h-full max-h-96">
        <table className="table table-zebra table-sm">
          <thead>
            <tr>
              <th>Device</th>
              <th>Start</th>
              <th>End</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center text-sm opacity-70">
                  No sensor history for this site.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.DeviceID ?? ""}</td>
                  <td>
                    {r.StartDate ? r.StartDate.toDate().toLocaleDateString("en-GB") : ""}
                  </td>
                  <td>
                    {r.EndDate ? r.EndDate.toDate().toLocaleDateString("en-GB") : "—"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end p-4">
        <button className="btn" onClick={unSetDialog}>Close</button>
      </div>
    </div>
  );
};
